import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  initState,
  sendRequest,
  changeFieldSum,
  selectRequestState,
  selectFieldSum
} from 'mt-react-common/modules/userFlowFunds/common/reducers/forms/transferFundsForm';

import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';
import InfoMaterialContent from '../../InfoMaterials/InfoMaterialContent';

const transferFundsFormRN = 'userFlowFundsModule.forms.transferFundsForm';

class TransferFundsForm extends Component {
  handleChangeField = async event => {
    switch (event.target.name) {
      case 'sum':
        this.props.changeFieldSum(event.target.value);
        break;
      default:
        break;
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.props.sendRequest();
  };

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <React.Fragment>
        {this.props.requestState.hasInProgress ? <OpacityPreLoader /> : null}
        <div className="row">
          <div className="col-sm-12 col-xs-24 m-b-20">
            <form onSubmit={this.handleSubmit}>
              <div
                className={`form-group ${
                  hasError(this.props.fieldSum.errors) ? 'has-error' : ''
                }`}
              >
                <label className="control-label" htmlFor="inputTransfer">
                  {t('Сумма перевода')}
                </label>
                <input
                  onChange={this.handleChangeField}
                  value={this.props.fieldSum.value}
                  type="number"
                  name="sum"
                  className="form-control"
                  placeholder={t('Введите сумму перевода')}
                  id="inputTransfer"
                />
                {errorDesc(this.props.fieldSum.errors)}
              </div>
              <button type="submit" className="btn btn-primary btn-block">
                {t('Перевести')}
              </button>
            </form>
          </div>
          <div className="col-sm-12 col-xs-24">
            <div className="alert alert-warning m-b-0">
              <InfoMaterialContent id={'transfer_funds'} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TransferFundsForm.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  initState: PropTypes.func.isRequired,
  changeFieldSum: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,

  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,

  fieldSum: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, transferFundsFormRN),
  fieldSum: selectFieldSum(state, transferFundsFormRN)
});

const mapDispatchToProps = dispatch => ({
  initState: () => dispatch(initState(transferFundsFormRN)),
  changeFieldSum: value => dispatch(changeFieldSum(transferFundsFormRN, value)),
  sendRequest: () => dispatch(sendRequest(transferFundsFormRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferFundsForm);



// WEBPACK FOOTER //
// ./src/components/UserFlowFunds/TransferFundsForm/TransferFundsForm.js